
import Vue from 'vue'

export default Vue.extend({
  name: 'Confirm',
  props: {
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '?',
    },
    skipConfirmation: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    activatorClicked() {
      if (this.skipConfirmation) {
        this.$emit('confirmed')
        return
      }
      this.dialog = true
    },
    yesClicked() {
      this.$emit('confirmed')
      this.dialog = false
    },
  },
})
